module["exports"] = ["6##-###-###", "6##.###.###", "6## ### ###", "6########"];